import React, { useState } from "react";
import Layout from "../../component/Layout";
import setting from "../../images/setting.svg";
import velocity from "../../images/velocity.svg";
import rocket from "../../images/rocket.svg";
import training from "../../images/training.svg";
import education from "../../images/education.svg";
import ladyRun from "../../images/ladyRun.png";
import { Link } from "react-router-dom";
type Product = {
  id: number;
  title: string;
  price: string;
  image: string;
  link: string;
};

type Tab = "speed" | "strength";
type Section = "training" | "tools" | "velocity" | "rocket" | "education";
const Tools = () => {
  // State to track the active tab
  const [activeTab, setActiveTab] = useState<Tab>("speed");
  const [activeSection, setActiveSection] = useState<Section | "">("");
  const [showProduct, setShowProduct] = useState(false);

  // Handler to change the active tab
  const handleTabClick = (tab: Tab) => {
    setActiveTab(tab);
  };
  const handleShowProducts = (section: Section) => {
    setActiveSection(section);
    setShowProduct(true);
  };
  return (
    <Layout>
      <div className="min-h-min h-full bg-[#F6F6F6]">
        <div className="w-full max-w-2xl mx-auto px-5">
          <>
            <button
              onClick={() => handleShowProducts("tools")}
              className={`${
                activeSection === "tools" ? "!font-semibold" : ""
              } py-5 w-full flex flex-row gap-4 border-b border-black/20 text-black text-sm font-normal transition group hover:font-bold`}
            >
              <div className="w-6">
              <img src={setting} alt="setting" className="object-contain" />
              </div>
              My Tools
            </button>
            <Link to="/teststep2">
              <button
                className={`py-5 w-full flex flex-row gap-4 border-b border-black/20 text-black text-sm font-normal transition group hover:font-bold`}
              >
                <div className="w-6">
                <img src={velocity} alt="velocity" className="object-contain" />
                </div>
                Load Velocity Profiling
              </button>
            </Link>
            <Link to="/rrteststep1">
              <button
                className={`py-5 w-full flex flex-row gap-4 border-b border-black/20 text-black text-sm font-normal transition group hover:font-bold`}
              >
                <div className="w-6">
                <img src={rocket} alt="rocket" className="object-contain" />
                </div>
                Run Rocket Training
              </button>
            </Link>
            <button
              onClick={() => handleShowProducts("training")}
              className={`${
                activeSection === "training" ? "!font-semibold" : ""
              } py-5 w-full flex flex-row gap-4 border-b border-black/20 text-black text-sm font-normal transition group hover:font-bold`}
            >
              <div className="w-6">
              <img src={training} alt="training" className="object-contain" />
              </div>
              Training Programs
            </button>
            <button
              onClick={() => handleShowProducts("education")}
              className={`${
                activeSection === "education" ? "!font-semibold" : ""
              } py-5 w-full flex flex-row gap-4 border-b border-black/20 text-black text-sm font-normal transition group hover:font-bold`}
            >
              <div className="w-6">
              <img src={education} alt="education" className="object-contain" />
              </div>
              Educational Courses
            </button>
          </>

          {showProduct && (
            <div className="tabbing mt-5" id="default-tab-content">
              {/* Tab header */}
              <div className="flex flex-row justify-center gap-[104px] mb-2">
                <p
                  className={`text-base font-normal pb-[11px] cursor-pointer ${
                    activeTab === "speed"
                      ? "text-black border-b border-black"
                      : "text-[#A5A5A5]"
                  }`}
                  onClick={() => handleTabClick("speed")}
                >
                  Speed
                </p>
                <p
                  className={`text-base font-normal pb-[11px] cursor-pointer ${
                    activeTab === "strength"
                      ? "text-black border-b border-black"
                      : "text-[#A5A5A5]"
                  }`}
                  onClick={() => handleTabClick("strength")}
                >
                  Strength
                </p>
              </div>

              {/* Tab content */}
              <div className="flex flex-wrap justify-center gap-x-[10px] gap-y-5 py-3 w-full max-w-[370px] mx-auto">
                {activeSection === "training" &&
                  (activeTab === "speed"
                    ? trainingSpeedProducts.map((product) => (
                        <Link to="/tooldetail" key={product.id}>
                          <div className="flex flex-col">
                            <div className="size-[169px] rounded-[15px] overflow-hidden mb-3">
                              <img
                                src={product.image}
                                alt={product.title}
                                className="object-cover"
                              />
                            </div>
                            <p className="text-black text-base font-normal">
                              {product.title}
                            </p>
                            <span className="text-black text-sm font-light openSans">
                              {product.price}
                            </span>
                          </div>
                        </Link>
                      ))
                    : trainingStrengthProducts.map((product) => (
                        <Link to="/tooldetail" key={product.id}>
                          <div className="flex flex-col">
                            <div className="size-[169px] rounded-[15px] overflow-hidden mb-3">
                              <img
                                src={product.image}
                                alt={product.title}
                                className="object-cover"
                              />
                            </div>
                            <p className="text-black text-base font-normal">
                              {product.title}
                            </p>
                            <span className="text-black text-sm font-light openSans">
                              {product.price}
                            </span>
                          </div>
                        </Link>
                      )))}
                {activeSection === "tools" &&
                  (activeTab === "speed"
                    ? myToolsSpeedProducts.map((product) => (
                        <Link to="/tooldetail" key={product.id}>
                          <div className="flex flex-col">
                            <div className="size-[169px] rounded-[15px] overflow-hidden mb-3">
                              <img
                                src={product.image}
                                alt={product.title}
                                className="object-cover"
                              />
                            </div>
                            <p className="text-black text-base font-normal">
                              {product.title}
                            </p>
                            <span className="text-black text-sm font-light openSans">
                              {product.price}
                            </span>
                          </div>
                        </Link>
                      ))
                    : myToolsStrengthProducts.map((product) => (
                        <Link to="/tooldetail" key={product.id}>
                          <div className="flex flex-col">
                            <div className="size-[169px] rounded-[15px] overflow-hidden mb-3">
                              <img
                                src={product.image}
                                alt={product.title}
                                className="object-cover"
                              />
                            </div>
                            <p className="text-black text-base font-normal">
                              {product.title}
                            </p>
                            <span className="text-black text-sm font-light openSans">
                              {product.price}
                            </span>
                          </div>
                        </Link>
                      )))}
                {activeSection === "education" &&
                  (activeTab === "speed"
                    ? myToolsSpeedProducts.map((product) => (
                        <Link to="/tooldetail" key={product.id}>
                          <div className="flex flex-col">
                            <div className="size-[169px] rounded-[15px] overflow-hidden mb-3">
                              <img
                                src={product.image}
                                alt={product.title}
                                className="object-cover"
                              />
                            </div>
                            <p className="text-black text-base font-normal">
                              {product.title}
                            </p>
                            <span className="text-black text-sm font-light openSans">
                              {product.price}
                            </span>
                          </div>
                        </Link>
                      ))
                    : myToolsStrengthProducts.map((product) => (
                        <Link to="/tooldetail" key={product.id}>
                          <div className="flex flex-col">
                            <div className="size-[169px] rounded-[15px] overflow-hidden mb-3">
                              <img
                                src={product.image}
                                alt={product.title}
                                className="object-cover"
                              />
                            </div>
                            <p className="text-black text-base font-normal">
                              {product.title}
                            </p>
                            <span className="text-black text-sm font-light openSans">
                              {product.price}
                            </span>
                          </div>
                        </Link>
                      )))}
              </div>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Tools;

const trainingSpeedProducts: Product[] = [
  {
    id: 1,
    title: "Speed Program 1",
    price: "$49.99",
    image: ladyRun,
    link: "/",
  },
  {
    id: 2,
    title: "Speed Program 2",
    price: "$59.99",
    image: ladyRun,
    link: "/",
  },
  {
    id: 3,
    title: "Speed Program 1",
    price: "$49.99",
    image: ladyRun,
    link: "/",
  },
  {
    id: 4,
    title: "Speed Program 2",
    price: "$59.99",
    image: ladyRun,
    link: "/",
  },
  {
    id: 5,
    title: "Speed Program 1",
    price: "$49.99",
    image: ladyRun,
    link: "/",
  },
  {
    id: 6,
    title: "Speed Program 2",
    price: "$59.99",
    image: ladyRun,
    link: "/",
  },
];

const trainingStrengthProducts: Product[] = [
  {
    id: 1,
    title: "Strength Program 1",
    price: "$59.99",
    image: ladyRun,
    link: "/",
  },
  {
    id: 2,
    title: "Strength Program 2",
    price: "$69.99",
    image: ladyRun,
    link: "/",
  },
];

const myToolsSpeedProducts: Product[] = [
  { id: 1, title: "Tool Speed 1", price: "$29.99", image: ladyRun, link: "/" },
  { id: 2, title: "Tool Speed 2", price: "$39.99", image: ladyRun, link: "/" },
];

const myToolsStrengthProducts: Product[] = [
  {
    id: 1,
    title: "Tool Strength 1",
    price: "$49.99",
    image: ladyRun,
    link: "/",
  },
  {
    id: 2,
    title: "Tool Strength 2",
    price: "$59.99",
    image: ladyRun,
    link: "/",
  },
];
